import type { FC } from "react";
import { Box, Typography } from "@mui/material";
import { ContentsList } from "@/shared/components/blocks/ContentsBlock";
import { useFeaturedContents, useTranslation } from "@/shared/hooks";

// Список «Похожие видео» (порт референсного RelatedContent → ArenaContents
// view=LIST): горизонтальные карточки на всю ширину с допагинацией по
// доскроллу (сентинел ContentsList). Оба варианта показывают заголовок
// "RELATED VIDEOS" (label-капс); variant="sidebar" живёт в десктопном
// сайдбаре с отступом сверху, variant="mobile" — блоком под ContentBody.
export const FeaturedVideos: FC<{
  contentId: string;
  variant: "sidebar" | "mobile";
}> = ({ contentId, variant }) => {
  const { t } = useTranslation();
  const { contents, loading, hasMore, loadMore, called } = useFeaturedContents({
    contentId,
    limit: 12,
  });

  if (contents.length === 0 && called && !loading) return null;

  return (
    <>
      {/* В десктопном сайдбаре заголовок уже даёт таб-бар ContentLayout,
          подпись нужна только мобильному блоку под описанием. */}
      {variant === "mobile" && (
        <Typography variant="label" sx={{ px: { xs: 1.875, sm: 3 }, pb: 1.5 }}>
          {t("video.similar.title")}
        </Typography>
      )}
      <Box sx={variant === "mobile" ? { py: 0 } : { pt: 1 }}>
        <ContentsList
          items={contents}
          previewMode="HORIZONTAL"
          size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          hasMore={hasMore}
          onLoadMore={loadMore}
          loading={loading}
        />
      </Box>
    </>
  );
};
